import { render, staticRenderFns } from "./EconomyCo2Component.vue?vue&type=template&id=98035684&"
import script from "./EconomyCo2Component.vue?vue&type=script&lang=js&"
export * from "./EconomyCo2Component.vue?vue&type=script&lang=js&"
import style0 from "./EconomyCo2Component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports